import { Link } from 'react-router-dom';
import type { Drama } from '@/types';
import { useFavorites } from '@/hooks/useFavorites';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const favorite = isFavorite(drama.id);

  return (
    <div className="group relative">
      <Link to={`/detail/${drama.id}`} className="block">
        <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
          <img
            src={drama.cover}
            alt={`${drama.title} 海报`}
            title={`${drama.title} 影视详情`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
          <span className="absolute left-2 top-2 rounded-md bg-primary-500/95 px-2 py-0.5 text-xs font-semibold text-background-50">
            {drama.rating.toFixed(1)}
          </span>
          <span className="absolute right-2 top-2 rounded-md bg-background-950/55 px-2 py-0.5 text-[11px] text-background-100 backdrop-blur">
            {drama.type === 'tv' ? '电视剧' : '电影'}
          </span>
          <div className="absolute inset-x-0 bottom-0 p-3">
            <p className="line-clamp-1 text-xs text-background-200">
              {drama.actors.slice(0, 2).join(' / ')}
            </p>
          </div>
        </div>
      </Link>

      <button
        type="button"
        onClick={() => toggleFavorite(drama.id)}
        className={`absolute bottom-[4.4rem] right-2 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full backdrop-blur transition-colors ${
          favorite
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-50/85 text-foreground-700 hover:text-primary-600'
        }`}
        aria-label={favorite ? '取消收藏' : '收藏'}
      >
        <i className={favorite ? 'ri-heart-fill text-base' : 'ri-heart-line text-base'}></i>
      </button>

      <div className="mt-2.5">
        <Link to={`/detail/${drama.id}`}>
          <h3 className="line-clamp-1 text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
            {drama.title}
          </h3>
        </Link>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
          {drama.year} · {drama.region} · {drama.genres.slice(0, 2).join(' ')}
        </p>
      </div>
    </div>
  );
}